import { CurecallBanner } from '@honestica/curecall-ui'
import { config } from 'src/config'

const EnvironmentBanner = () => {
  if (config.ENVIRONMENT === 'dev' || config.ENVIRONMENT === 'staging') {
    return (
      <CurecallBanner
        appearance="WARNING"
        className="tw-m-0 tw-p-2 [&>*]:tw-w-5"
        actionLabel="Aller sur l'application Curecall"
        action={() => {
          window.location.href = 'https://app.curecall.com'
        }}
      >
        {}
        Cette plateforme est destinée aux tests internes à Curecall.
      </CurecallBanner>
    )
  }
  return null
}

export default EnvironmentBanner
